import { MARKETING_COLORS } from "@vp/marketing-colors";

export const SITE_HEADER_NAV_SKIN_HOLIDAY = 'site-header-nav-skin-holiday';
export const HOLIDAY_RED_COLOR_CODE = MARKETING_COLORS['holiday'].code;